// library imports
import { useState } from "react";
// hook imports
import useFetch from "../hooks/useFetch";

export default function useHasGenset() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasGensetLoading, setGetHasGensetLoading] = useState(false);

  // this state is to check whether the site has genset
  const [hasGenset, setHasGenset] = useState(false);

  /* API to check whether site has genset that is selected and not deleted */
  function getHasGenset({ siteSelected }) {
    setGetHasGensetLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasDevice",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        device_prefix: "GENSET",
      },
      onSuccess: (response) => {
        setGetHasGensetLoading(false);
        setHasGenset(response.data);
      },
    });
  }

  return [hasGenset, getHasGenset, getHasGensetLoading];
}
